import{o as e,p as s,T as a}from"./styled-ce4e5d22.js";function o({props:o,name:p}){return e({props:o,name:p,defaultTheme:s,themeId:a})}export{o as u};
//# sourceMappingURL=useThemeProps-0bd8c207.js.map
